import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from "react-redux";

const SidebarNav = () => {
    const menu = useSelector(state => state.menu.items);

    const renderMenu = (items) => {
        return items.map((item, index) => (
            <li className="nav-item" key={item.name + index}>
                <NavLink
                    to={item.url}
                    className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                >
                    {item.name}
                </NavLink>

                {item.children && (
                    <ul className="navbar-nav flex-column ps-3">
                        {renderMenu(item.children)}
                    </ul>
                )}
            </li>
        ));
    };

    return (
        <div className="navbar w-100 align-items-start">
            <ul className="navbar-nav flex-column w-100">
                {renderMenu(menu)}
            </ul>
        </div>
    );

};

export default SidebarNav;
